import { useRouter } from 'next/router';
import { Button, DashedLine, Text } from '@belong/ui';
import { UnitListingDetailsModel } from 'src/api/models';
import { HOUSE_PAGE_STRINGS } from 'src/features/house-page/house-page.strings';
import { SelfTourCard } from '../self-tour-card';

type SelfTourPreviewProps = {
  home: UnitListingDetailsModel;
  onSignIn: (backTo?: string) => void;
};

export function SelfTourPreview({ home, onSignIn }: SelfTourPreviewProps) {
  const router = useRouter();
  const homeId = home.basicInfo!.unitId!;

  return (
    <div className="w-full">
      <div className="mb-xl px-sm m-auto text-center">
        <Text variant="h2" fontWeight="semibold">
          {HOUSE_PAGE_STRINGS['tour.comeSeeThisHome']}
        </Text>
        <Text className="mt-xs text-dark-gray">
          {HOUSE_PAGE_STRINGS['tour.chooseHowToSee']}
        </Text>
      </div>
      <div className="px-sm pb-3xl">
        <SelfTourCard
          homeId={homeId}
          href={`/homes/${router.query.slug}/${homeId}/self-tour`}
          timeZone={home.basicInfo?.timeZone}
          onSelect={onSignIn}
        />
        <div className="gap-sm my-xl flex items-center">
          <DashedLine />
          <Text variant="p1" className="text-gray shrink-0">
            {HOUSE_PAGE_STRINGS['tour.or']}
          </Text>
          <DashedLine />
        </div>
        <div className="flex justify-center">
          <Button variant="text" onClick={() => onSignIn()}>
            {HOUSE_PAGE_STRINGS['tour.signInForGroupTours']}
          </Button>
        </div>
      </div>
    </div>
  );
}
